<template>
  <v-app>
    <notifyWrapper/>
    <RefreshAppAlert />
    <!-- APPLICATION BAR  -->
    <v-app-bar
      style="box-shadow:0 0 20px rgba(0, 0, 0, 0.13)"
      id="home-app-bar"
      flat
      app
      color="#F5F6F7"
    >
    <v-btn v-if="needShowBurgerMenu" icon @click="drawer = !drawer">
      <v-icon>mdi mdi-menu</v-icon>
    </v-btn>
      <v-col lg="3">
        <v-text-field
          flat
          solo
          background-color="transparent"
          hide-details
          append-icon="mdi-magnify"
          label="Search"
          class="hidden-sm-and-down"
          v-model="globalSearch"
        ></v-text-field>
      </v-col>

      <v-spacer />

      <lang-switcher />
      <notifications color="orange"/>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-list dense style="background:transparent;" class="py-0 px-3">
            <v-list-item v-on="on" two-line :class="'px-0'">
              <v-list-item-avatar v-if="authData">
                <v-img v-if="!needDefaultImage" :src="authData.userPhoto" @load="load() " @error="error()"/>
                <img v-else src="../assets/user-account.png"/>
              </v-list-item-avatar>

              <v-list-item-content v-if="authData" style="flex-direction:column; align-items:start">
                <v-list-item-title>{{ authData.userName }}</v-list-item-title>
                <v-list-item-subtitle>{{ authData.login }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title @click="$authCore.SignOut()">{{$t('login.signOut')}}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- NAVIGATION -->

    <v-navigation-drawer
      :right="$vuetify.rtl"
      elevation="1"
      floating
      app
      v-model="drawer"
      :expand-on-hover="minidrawer"
      width="300"
    >
      <div class="logo">
        <img
          :src="logoUrl"
          height="33px"
          class="pl-3 full-logo"
        />
        <img :src="minLogoUrl" height="33px" class="pl-3 small-logo" />
      </div>

      <NavigationMenu :items="sidebarItems" />
    </v-navigation-drawer>

    <!-- CONTENT -->
    <v-main  style="background:#f1f4f6">
      <v-progress-linear
      v-if="loader"
      indeterminate
      height="5"
      color="primary"
      absolute
    ></v-progress-linear>
      <v-container fluid>
        <dr-layout-placeholder :model="{$ID:'pl3'+this.routeName, Name:'Main'}"></dr-layout-placeholder>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import LangSwitcher from '@/components/LangSwitcher'
import inputMixin from '@it-enterprise/web-app-common/src/mixins/input-mixin'
import layoutMixin from '@it-enterprise/web-app-common/src/mixins/layout-mixin'
import NotifyWrapper from '@/components/NotifyWrapper'
import Notifications from '@/components/Notifications'
import RefreshAppAlert from '@/components/RefreshAppAlert'
export default {
  name: 'MainLayout',
  mixins: [inputMixin, layoutMixin],
  components: {
    LangSwitcher,
    NotifyWrapper,
    Notifications,
    RefreshAppAlert
  },
  data: () => ({
    drawer: true,
    minidrawer: true,
    items: [
      { title: 'Dashboard', icon: 'mdi-view-dashboard' },
      { title: 'Photos', icon: 'mdi-image' },
      { title: 'About', icon: 'mdi-help-box' }
    ],
    needDefaultImage: false
  }),
  computed: {
    authData() {
      return this.$store.state.auth.user?.authData || null
    },
    routeName() {
      return this.$route.name
    },
    sidebarItems() {
      return this.$store.getters.AppNavigation
    },
    loader() {
      return this.$store.getters.getProcessing
    },
    needShowBurgerMenu() {
      if (this.$vuetify.breakpoint.name == 'xl' || this.$vuetify.breakpoint.name == 'lg') { 
        this.setModeDrawer(true)
        return false
      }
      this.setModeDrawer(false)
      return true
    },
    globalSearch: {
      get() {
        return this.$store.state.general.globalSearch
      },
      set(v) {
        this.$store.commit('SET_GLOBAL_SEARCH', v)
      }
    }
  },
  methods: {
    setModeDrawer(value) {
      this.minidrawer = value
    },
    load() {
      this.needDefaultImage = false
    },
    error() {
      this.needDefaultImage = true
    }
  }
}
</script>

<style lang="scss" >
nav.v-navigation-drawer {
  box-shadow: 0 0px 18px 0px rgba(0, 0, 0, 0.06);
}
.small-logo {
  display: none;
}
.logo {
  height: 75px;
  background: #fafbfc;
  display: flex;
  align-items: center;
}
.v-navigation-drawer--mini-variant {
  .full-logo {
    display: none;
  }
  .small-logo {
    display: block;
  }
}

.drawer-toggler {
  $border: 1px solid #e2e5e7;
  display: flex;
  position: absolute;
  width: 20px;
  height: 20px;
  right: 0;
  top: 25px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-left: $border;
  border-top: $border;
  border-bottom: $border;
  cursor: pointer;
  z-index: 1000;
  i {
    display: block;
    font-size: 20px;
  }
}
</style>